import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 16,
	viewBox: "0 0 13 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.89062 15.1406C7.00781 15.1406 7.19531 15.0938 7.38281 15C11.6016 12.8125 12.9688 11.6953 12.9688 9.03906V3.49219C12.9688 2.69531 12.6328 2.42969 11.9844 2.15625C11.1328 1.80469 8.39062 0.8125 7.55469 0.53125C7.34375 0.460938 7.10938 0.421875 6.89062 0.421875C6.66406 0.421875 6.4375 0.46875 6.22656 0.53125C5.38281 0.796875 2.64062 1.8125 1.79688 2.15625C1.14062 2.42188 0.804688 2.69531 0.804688 3.49219V9.03906C0.804688 11.6953 2.25 12.6875 6.39062 15C6.57812 15.1016 6.76562 15.1406 6.89062 15.1406ZM4.14062 10.3984V7.38281C4.14062 6.84375 4.35938 6.57812 4.79688 6.54688V5.66406C4.79688 4.25 5.64062 3.3125 6.89062 3.3125C8.13281 3.3125 8.98438 4.25 8.98438 5.66406V6.54688C9.42188 6.57812 9.64062 6.84375 9.64062 7.38281V10.3984C9.64062 10.9688 9.38281 11.2344 8.85156 11.2344H4.92188C4.39062 11.2344 4.14062 10.9688 4.14062 10.3984ZM5.63281 6.53125H8.14062V5.57812C8.14062 4.70312 7.64062 4.11719 6.89062 4.11719C6.13281 4.11719 5.63281 4.70312 5.63281 5.57812V6.53125Z",
		fill: "currentColor"
	})
});
export default SvgShieldLock;
